export default "__VITE_ASSET__BFpCog$g__"